var initialState = {
  ui: {
    isRequesting: false,
    isUpdating: false,
    isMerging: false
  },
  data: {
    wishlists: [{
      id: null,
      name: null,
      items: []
    }]
  },
  error: null
};
export default initialState;